const onboardingData = [
  {
    title: "See available venues",
    copy: "View photos and the details of the venues that are interested in hosting your event.",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/reccos/onboarding/space-card.png",
  },
  {
    title: "Confirm the details",
    copy: `Message the venues you're interested in with any questions you have.`,
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/reccos/onboarding/chat.png",
  },
  {
    title: "Book the perfect space",
    copy: `Once you've found the right space, simply let the venue know you're ready to book.`,
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/reccos/onboarding/book.png",
  },
];

module.exports = { onboardingData };
